import type { RouteRecordRaw } from 'vue-router';
import Dashboard from '@pages/Dashboard.vue';
import Overview from '@pages/dashboard/Overview.vue';
import DashboardMap from '@pages/dashboard/Map.vue';
import Distribution from '@pages/dashboard/Distribution.vue';
import DriverLocations from '@pages/dashboard/DriverLocations.vue';
import DriversLayout from '@pages/Drivers.vue';
import Drivers from '@pages/drivers/Drivers.vue';
import DriverDetails from '@pages/drivers/driver/Details.vue';
import DriverCampaigns from '@pages/drivers/driver/Campaigns.vue';
import DriverPayouts from '@pages/drivers/driver/Payouts.vue';
import DriverPayoutCredits from '@pages/drivers/driver/PayoutCreditDebts.vue';
import DriverTours from '@pages/drivers/driver/Tours.vue';
import DriverHistory from '@pages/drivers/driver/History.vue';
import DriverNotifications from '@pages/drivers/driver/Notifications.vue';
import DriverPoints from '@pages/drivers/driver/Points.vue';
import ToursLayout from '@pages/Tours.vue';
import Tours from '@pages/tours/Tours.vue';
import DriverFocusPoints from '@pages/drivers/driver/FocusPoints.vue';
import CampaignGroupsLayout from '@pages/Campaigns.vue';
import CampaignGroups from '@pages/campaigns/CampaignGroups.vue';
import CampaignTours from '@pages/campaigns/campaignGroup/Tours.vue';
import CampaignTourMap from '@pages/campaigns/campaignGroup/TourMap.vue';
import CampaignGroup from '@pages/campaigns/CampaignGroup.vue';
import CampaignGroupDetails from '@pages/campaigns/campaignGroup/Campaigns.vue';
import CampaignDrivers from '@pages/campaigns/campaignGroup/Drivers.vue';
import CampaignDriverLocations from '@pages/campaigns/campaignGroup/DriverLocations.vue';
import CampaignCandidates from '@pages/campaigns/campaignGroup/Candidates.vue';
import CampaignWaitingList from '@pages/campaigns/campaignGroup/WaitingList.vue';
import CampaignPayouts from '@pages/campaigns/campaignGroup/Payouts.vue';
import CampaignFocusPoints from '@pages/campaigns/campaignGroup/FocusPoints.vue';
import CampaignFocusPoint from '@pages/campaigns/campaignGroup/FocusPoint.vue';
import CampaignFocusPointDetails from '@pages/campaigns/campaignGroup/focusPoint/FocusPoint.vue';
import CampaignStatisticPoints from '@pages/campaigns/campaignGroup/StatisticPoints.vue';
import CampaignNotifications from '@pages/campaigns/campaignGroup/Notifications.vue';
import Campaigns from '@pages/campaigns/Campaigns.vue';
import Login from '@pages/auth/Login.vue';
import ForgotPassword from '@pages/auth/ForgotPassword.vue';
import UsersLayout from '@pages/Users.vue';
import Users from '@pages/users/Users.vue';
import UserDetails from '@pages/users/user/Details.vue';
import Videos from '@pages/content/video/Videos.vue';
import VideoCategories from '@pages/content/video/VideoCategories.vue';
import FaqLayout from '@pages/Faq.vue';
import ActiveMountings from '@pages/mountings/ActiveMountings.vue';
import PassiveMountings from '@pages/mountings/PassiveMountings.vue';
import ArchivedMountings from '@pages/mountings/ArchivedMountings.vue';
import Mounting from '@pages/mountings/Mounting.vue';
import ActiveMountingTimeslots from '@pages/mountings/mounting/ActiveTimeslots.vue';
import ClosedMountingTimeslots from '@pages/mountings/mounting/ClosedTimeslots.vue';
import PendingRegistrations from '@pages/mountings/mounting/timeslots/PendingRegistrations.vue';
import CompletedRegistrations from '@pages/mountings/mounting/timeslots/CompletedRegistrations.vue';
import ApprovedRegistrations from '@pages/mountings/mounting/timeslots/ApprovedRegistrations.vue';
import MountingDriversPendingRegistrations from '@pages/mountings/drivers/PendingRegistrations.vue';
import MountingDriversCompletedRegistrations
  from '@pages/mountings/drivers/CompletedRegistrations.vue';
import MountingDriversApprovedRegistrations
  from '@pages/mountings/drivers/ApprovedRegistrations.vue';
import CompaniesLayout from '@pages/Companies.vue';
import Companies from '@pages/companies/Companies.vue';
import NotificationsLayout from '@pages/Notifications.vue';
import Notifications from '@pages/notifications/Notifications.vue';
import NotificationSent from '@pages/notifications/SentNotifications.vue';
import VisibilityPlanningsLayout from '@pages/VisibilityPlanningsLayout.vue';
import VisibilityTransfersLayout from '@pages/VisibilityTransfersLayout.vue';
import VisibilityBicyclesLayout from '@pages/VisibilityBicyclesLayout.vue';
import VisibilityLocationsLayout from '@pages/VisibilityLocationsLayout.vue';
import LoyaltyLayout from '@pages/Loyalty.vue';
import InterestZones from '@pages/loyalty/InterestZones.vue';
import TemplatesLayout from '@pages/Templates.vue';
import FocusPointTemplates from '@pages/templates/FocusPointTemplates.vue';
import PhotosLayout from '@pages/images/Photos.vue';
import NewPhotos from '@pages/images/photos/NewPhotos.vue';
import HistoryPhotos from '@pages/images/photos/HistoryPhotos.vue';
import NewVerifications from '@pages/images/verifications/NewVerifications.vue';
import HistoryVerifications from '@pages/images/verifications/HistoryVerifications.vue';
import VerificationsLayout from '@pages/images/Verifications.vue';
import LicensesLayout from '@pages/Licenses.vue';
import AdvertisementsLayout from '@pages/Advertisements.vue';
import Advertisements from '@pages/advertisements/Advertisements.vue';
import Agb from '@pages/settings/Agb.vue';
import PointRewardDetails from '@pages/loyalty/pointReward/PointReward.vue';
import PointRewards from '@pages/loyalty/PointRewards.vue';
import InterestZoneDetails from '@pages/loyalty/interestZone/InterestZone.vue';
import InterestZone from '@pages/loyalty/InterestZone.vue';
import MountingTimeslotLayout from '@pages/mountings/mounting/MountingTimeslot.vue';
import PointReward from '@pages/loyalty/PointReward.vue';
import HistoryGeneral from '@pages/history/HistoryGeneral.vue';
import HistoryLayout from '@pages/History.vue';
import HistoryDriver from '@pages/history/HistoryDriver.vue';
import HistoryUsage from '@pages/history/HistoryUsage.vue';
import Surplus from '@pages/campaigns/campaignGroup/Surplus.vue';
import StatisticPointTemplates from '@pages/templates/StatisticPointTemplates.vue';
import DraftVisibilityPlannings
  from '@pages/visibility/visibilityPlanning/DraftVisibilityPlannings.vue';
import ConfirmedVisibilityPlannings
  from '@pages/visibility/visibilityPlanning/ConfirmedVisibilityPlannings.vue';
import PassedVisibilityPlannings
  from '@pages/visibility/visibilityPlanning/PassedVisibilityPlannings.vue';
import CurrentVisibilityTransfers from '@pages/visibility/visibilityTransfer/CurrentVisibilityTransfers.vue';
import DoneVisibilityTransfers
  from '@pages/visibility/visibilityTransfer/DoneVisibilityTransfers.vue';
import UsageVisibilityBicycles
  from '@pages/visibility/visibilityBicycle/UsageVisibilityBicycles.vue';
import CurrentVisibilityBicycles
  from '@pages/visibility/visibilityBicycle/CurrentVisibilityBicycles.vue';
import ArchivedVisibilityBicycles
  from '@pages/visibility/visibilityBicycle/ArchivedVisibilityBicycles.vue';
import ArchivedVisibilityLocations
  from '@pages/visibility/visibilityLocation/ArchivedVisibilityLocations.vue';
import CurrentVisibilityLocations
  from '@pages/visibility/visibilityLocation/CurrentVisibilityLocations.vue';
import VisibilityPhotosLayout from '@pages/VisibilityPhotosLayout.vue';
import VisibilityPhotos from '@pages/visibility/visibilityPhoto/VisibilityPhotos.vue';
import InactiveVisibilityLocations
  from '@pages/visibility/visibilityLocation/InactiveVisibilityLocations.vue';
import UsageVisibilityLocations
  from '@pages/visibility/visibilityLocation/UsageVisibilityLocations.vue';
import SegmentedDrivers from '@pages/drivers/SegmentedDrivers.vue';
import ResetPassword from '@/pages/auth/ResetPassword.vue';
import Page404 from '@/pages/Page404.vue';
import InvoicesLayout from '@/pages/InvoicesLayout.vue';
import AdditionalPaymentsLayout from '@/pages/AdditionalPaymentsLayout.vue';
import Invoices from '@/pages/invoices/Invoices.vue';
import Profile from '@/pages/profile/Index.vue';
import Driver from '@/pages/drivers/Driver.vue';
import User from '@/pages/users/User.vue';
import ConfirmEmail from '@/pages/auth/ConfirmEmail.vue';
import FaqQuestions from '@/pages/content/faq/FaqQuestions.vue';
import FaqSections from '@/pages/content/faq/FaqSections.vue';
import MountingLayout from '@/pages/Mounting.vue';
import Settings from '@/pages/Settings.vue';
import Logs from '@/pages/users/Logs.vue';
import General from '@/pages/settings/General.vue';
import DriverCommentTypes from '@/pages/settings/DriverCommentTypes.vue';
import Integrations from '@/pages/settings/Integrations.vue';
import store from '@/store';
import { canAccess } from '@/utils/user';
import type { User as UserType } from '@/entities/Entities';
import Licenses from '@/pages/licenses/Licenses.vue';
import LicensesCompanies from '@/pages/licenses/Companies.vue';
import LicensesCompanyLayout from '@/pages/licenses/company/Layout.vue';
import LicensesCompanyLicenses from '@/pages/licenses/company/Licenses.vue';
import LicensesCompanyDrivers from '@/pages/licenses/company/Drivers.vue';
import LicensesCompanyTours from '@/pages/licenses/company/Tours.vue';
import LicensesCompanyTourMap from '@/pages/licenses/company/TourMap.vue';
import LicensesCompanyPayouts from '@/pages/licenses/company/Payouts.vue';
import LicensesCompanyReporting from '@/pages/licenses/company/Reporting.vue';
import MonitoringLayout from '@/pages/Monitoring.vue';
import MonitoringDriverVerifications from '@/pages/monitoring/DriverVerifications.vue';
import MonitoringCampaignVerifications from '@/pages/monitoring/CampaignVerifications.vue';
import AdditionalPaymentsList from '@/pages/additionalPayments/AdditionalPaymentsList.vue';

export function homeRoute(user: UserType) {
  if (!user) return undefined;

  const allowedChildRoute = (route: RouteRecordRaw) =>
    route.children?.find(
      (r: RouteRecordRaw) =>
        // Find child route that is on the same path as the parent
        (r.path === '' || (r.path === '/' && r.name)) &&
        // Check user-access to that route
        (!r.meta?.roles || canAccess(user, r.meta.roles as string[])),
    );

  // eslint-disable-next-line no-use-before-define
  const firstAllowedRoute = routes.find(
    (r: RouteRecordRaw) =>
      // Public routes are not considered for finding the redirect
      r.meta?.layout !== 'public' &&
      // Redirects are also excluded
      !r.redirect &&
      // We consider the parent route if the user has access and
      // either an accessable child route exists, the parent has no children or
      // if the parent explicitely states a name.
      (!r.meta?.roles || canAccess(user, r.meta.roles as string[])) &&
      (!!allowedChildRoute(r) || !r.children?.length || r.name),
  );

  if (firstAllowedRoute) {
    // Route to the child if there is an accessable child
    const targetRoute = allowedChildRoute(firstAllowedRoute) ?? firstAllowedRoute;
    return { name: targetRoute.name };
  }

  console.warn('No route to go home to');

  return undefined;
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect() {
      const locale = 'de'; // Default locale
      if (!store.state.auth.user) {
        return { name: 'dashboard', params: { locale } };
      }
      return homeRoute(store.state.auth.user) ?? { name: 'dashboard', params: { locale } };
    },
    name: 'home',
  },
  {
    path: '/:locale/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/:locale/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/:locale?/reset-password/:token',
    name: 'resetPassword',
    component: ResetPassword,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/:locale?/confirm-email/:token',
    name: 'confirmEmail',
    component: ConfirmEmail,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/:locale/dashboard',
    component: Dashboard,
    alias: ['/:locale'],
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      tabs: [
        { label: 'navigation.dashboard.overview', link: '/dashboard' },
        { label: 'navigation.dashboard.map', link: '/dashboard/map' },
        { label: 'navigation.dashboard.distribution', link: '/dashboard/distribution' },
        { label: 'navigation.dashboard.driverLocations', link: '/dashboard/driver-locations' },
      ],
    },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: Overview,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'map',
        name: 'map',
        component: DashboardMap,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'distribution',
        name: 'distribution',
        component: Distribution,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'driver-locations',
        name: 'driver-locations',
        component: DriverLocations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/tours',
    component: ToursLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.tours.DEFAULT',
        link: { name: 'dashboard' },
      },
      breadcrumbs: [
        {
          label: 'navigation.tours.DEFAULT',
          link: '/tours',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'tours',
        component: Tours,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/campaigns',
    component: CampaignGroupsLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.campaigns.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        { label: 'navigation.campaigns.groupOverview', link: { name: 'campaign-groups' } },
        { label: 'navigation.campaigns.campaignOverview', link: { name: 'campaigns' } },
      ],
      breadcrumbs: [
        {
          label: 'navigation.campaigns.DEFAULT',
          link: '/campaigns',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'campaign-groups',
        component: CampaignGroups,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'campaigns',
        name: 'campaigns',
        component: Campaigns,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'campaign-groups/:campaignGroupId',
        component: CampaignGroup,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [
            {
              label: 'navigation.campaigns.group.groups',
              link: { name: 'campaign-group-details' },
            },
            {
              label: 'navigation.campaigns.group.candidates',
              link: { name: 'campaign-group-candidates' },
            },
            {
              label: 'navigation.campaigns.group.drivers',
              link: { name: 'campaign-group-drivers' },
            },
            {
              label: 'navigation.dashboard.driverLocations',
              link: { name: 'campaign-group-driver-locations' },
            },
            {
              label: 'navigation.campaigns.group.waitingList',
              link: { name: 'campaign-group-waiting-list' },
            },
            { label: 'navigation.campaigns.group.tours', link: { name: 'campaign-group-tours' } },
            {
              label: 'navigation.campaigns.group.tourMap',
              link: { name: 'campaign-group-tour-map' },
            },
            {
              label: 'navigation.campaigns.group.payouts',
              link: { name: 'campaign-group-payouts' },
            },
            {
              label: 'navigation.campaigns.group.focusPoints',
              link: { name: 'campaign-group-focus-points' },
            },
            {
              label: 'navigation.campaigns.group.notifications',
              link: { name: 'campaign-group-notifications' },
            },
            {
              label: 'navigation.campaigns.group.statisticPoints',
              link: { name: 'campaign-group-statistic-points' },
            },
            {
              label: 'navigation.campaigns.group.surpluses',
              link: { name: 'campaign-group-surpluses' },
            },
          ],
          breadcrumbs: [
            {
              label: 'navigation.campaigns.group.groups',
              link: '/campaigns',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'campaign-group-details',
            component: CampaignGroupDetails,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.groupDetails',
            },
          },
          {
            path: 'candidates',
            name: 'campaign-group-candidates',
            component: CampaignCandidates,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.candidates',
            },
          },
          {
            path: 'drivers',
            name: 'campaign-group-drivers',
            component: CampaignDrivers,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.drivers',
            },
          },
          {
            path: 'driver-locations',
            name: 'campaign-group-driver-locations',
            component: CampaignDriverLocations,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.dashboard.driverLocations',
            },
          },
          {
            path: 'waiting-list',
            name: 'campaign-group-waiting-list',
            component: CampaignWaitingList,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.waitingList',
            },
          },
          {
            path: 'tours',
            name: 'campaign-group-tours',
            component: CampaignTours,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.tours',
            },
          },
          {
            path: 'map',
            name: 'campaign-group-tour-map',
            component: CampaignTourMap,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.tourMap',
            },
          },
          {
            path: 'payouts',
            name: 'campaign-group-payouts',
            component: CampaignPayouts,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.payouts',
            },
          },
          {
            path: 'focus-points',
            name: 'campaign-group-focus-points',
            component: CampaignFocusPoints,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.focusPoints',
            },
          },
          {
            path: 'focus-points/:focusPointId',
            name: 'campaign-group-focus-point-base',
            component: CampaignFocusPoint,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.focusPoints',
              breadcrumbs: [
                {
                  label: 'navigation.campaigns.group.groups',
                  link: { name: 'campaign-groups' },
                },
              ],
              tabs: [],
            },
            children: [
              {
                path: '',
                name: 'campaign-group-focus-point-details',
                component: CampaignFocusPointDetails,
                meta: {
                  roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
                  title: 'navigation.campaigns.group.focusPointDetails',
                },
              },
            ],
          },
          {
            path: 'notifications',
            name: 'campaign-group-notifications',
            component: CampaignNotifications,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.notifications',
            },
          },
          {
            path: 'statistic-points',
            name: 'campaign-group-statistic-points',
            component: CampaignStatisticPoints,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.statisticPoints',
            },
          },
          {
            path: 'campaign-surpluses',
            name: 'campaign-group-surpluses',
            component: Surplus,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.campaigns.group.surpluses',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/companies',
    component: CompaniesLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.companies.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [],
      breadcrumbs: [
        {
          label: 'navigation.companies.DEFAULT',
          link: '/companies',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'companies',
        component: Companies,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/licenses',
    component: LicensesLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.licenses.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.licenses.companies',
          link: { name: 'licenses-companies' },
        },
        {
          label: 'navigation.licenses.DEFAULT',
          link: { name: 'licenses' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.licenses.DEFAULT',
          link: '/licenses',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'licenses',
        component: Licenses,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'companies',
        name: 'licenses-companies',
        component: LicensesCompanies,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'companies/:companyId',
        name: 'licenses-company-details',
        component: LicensesCompanyLayout,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [
            {
              label: 'navigation.licenses.company.licenses',
              link: { name: 'company-license-details' },
            },
            {
              label: 'navigation.licenses.company.reporting',
              link: { name: 'company-license-reporting' },
            },
            {
              label: 'navigation.licenses.company.drivers',
              link: { name: 'company-license-drivers' },
            },
            {
              label: 'navigation.licenses.company.tours',
              link: { name: 'company-license-tours' },
            },
            {
              label: 'navigation.licenses.company.map',
              link: { name: 'company-license-map' },
            },
            {
              label: 'navigation.licenses.company.payouts',
              link: { name: 'company-license-payouts' },
            },
          ],
          breadcrumbs: [
            {
              label: 'navigation.licenses.DEFAULT',
              link: '/licenses',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'company-license-details',
            component: LicensesCompanyLicenses,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.licenses.company.details',
            },
          },
          {
            path: 'reporting',
            name: 'company-license-reporting',
            component: LicensesCompanyReporting,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.licenses.company.reporting',
            },
          },
          {
            path: 'drivers',
            name: 'company-license-drivers',
            component: LicensesCompanyDrivers,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.licenses.company.drivers',
            },
          },
          {
            path: 'tours',
            name: 'company-license-tours',
            component: LicensesCompanyTours,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.licenses.company.tours',
            },
          },
          {
            path: 'map',
            name: 'company-license-map',
            component: LicensesCompanyTourMap,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.licenses.company.map',
            },
          },
          {
            path: 'payouts',
            name: 'company-license-payouts',
            component: LicensesCompanyPayouts,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.licenses.company.payouts',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/drivers',
    component: DriversLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'drivers',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.drivers.DEFAULT',
          link: { name: 'drivers' },
        },
        {
          label: 'navigation.drivers.segmentation',
          link: { name: 'segmentation-drivers' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.drivers.DEFAULT',
          link: '/drivers',
        },
        {
          label: 'navigation.drivers.segmentation',
          link: '/drivers/segmentation',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'drivers',
        component: Drivers,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: '/:locale/drivers/segmentation-drivers',
        name: 'segmentation-drivers',
        component: SegmentedDrivers,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: '/:locale/drivers/:driverId',
        component: Driver,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [
            { label: 'navigation.drivers.driver.details', link: { name: 'driver-details' } },
            { label: 'navigation.drivers.driver.campaigns', link: { name: 'driver-campaigns' } },
            { label: 'navigation.drivers.driver.tours', link: { name: 'driver-tours' } },
            { label: 'navigation.drivers.driver.history', link: { name: 'driver-history' } },
            { label: 'navigation.drivers.driver.payouts', link: { name: 'driver-payouts' } },
            {
              label: 'navigation.drivers.driver.payoutCredits',
              link: { name: 'driver-payout-credits' },
            },
            {
              label: 'navigation.drivers.driver.notifications',
              link: { name: 'driver-notifications' },
            },
            { label: 'navigation.drivers.driver.points', link: { name: 'driver-points' } },
            {
              label: 'navigation.drivers.driver.focusPoints',
              link: { name: 'driver-focus-points' },
            },
          ],
          breadcrumbs: [
            {
              label: 'navigation.drivers.DEFAULT',
              link: '/drivers',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'driver-details',
            component: DriverDetails,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.details',
            },
          },
          {
            path: 'campaigns',
            name: 'driver-campaigns',
            component: DriverCampaigns,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.campaigns',
            },
          },
          {
            path: 'tours',
            name: 'driver-tours',
            component: DriverTours,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.tours',
            },
          },
          {
            path: 'history',
            name: 'driver-history',
            component: DriverHistory,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.history',
            },
          },
          {
            path: 'payouts',
            name: 'driver-payouts',
            component: DriverPayouts,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.payouts',
            },
          },
          {
            path: 'payout-credits',
            name: 'driver-payout-credits',
            component: DriverPayoutCredits,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.payoutCredits',
            },
          },
          {
            path: 'notifications',
            name: 'driver-notifications',
            component: DriverNotifications,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.notifications',
            },
          },
          {
            path: 'points',
            name: 'driver-points',
            component: DriverPoints,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.points',
            },
          },
          {
            path: 'focus-points',
            name: 'driver-focus-points',
            component: DriverFocusPoints,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.drivers.driver.focusPoints',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/mountings',
    component: MountingLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
      title: {
        text: 'navigation.mountings.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.mountings.active',
          link: { name: 'mountings-active' },
        },
        {
          label: 'navigation.mountings.passive',
          link: { name: 'mountings-passive' },
        },
        {
          label: 'navigation.mountings.archived',
          link: { name: 'mountings-archived' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.mountings.DEFAULT',
          link: '/mountings',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'mountings-active',
        component: ActiveMountings,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
        },
      },
      {
        path: 'passive',
        name: 'mountings-passive',
        component: PassiveMountings,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
        },
      },
      {
        path: 'archived',
        name: 'mountings-archived',
        component: ArchivedMountings,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: '/:locale/mountings/:mountingId',
        component: Mounting,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [
            {
              label: 'navigation.mountings.mounting.activeTimeslots',
              link: { name: 'mounting-timeslots-active' },
            },
            {
              label: 'navigation.mountings.mounting.closedTimeslots',
              link: { name: 'mounting-timeslots-closed' },
            },
          ],
          breadcrumbs: [
            {
              label: 'navigation.mountings.DEFAULT',
              link: '/mountings',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'mounting-timeslots-active',
            component: ActiveMountingTimeslots,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
              title: 'navigation.mountings.mounting.activeTimeslots',
            },
          },
          {
            path: 'closed',
            name: 'mounting-timeslots-closed',
            component: ClosedMountingTimeslots,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
              title: 'navigation.mountings.mounting.closedTimeslots',
            },
          },
          {
            path: '/:locale/mountings/:mountingId/timeslots',
            component: MountingTimeslotLayout,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              tabs: [
                {
                  label: 'navigation.mountings.mounting.timeslot.pending',
                  link: { name: 'mounting-timeslot-registrations-pending' },
                },
                {
                  label: 'navigation.mountings.mounting.timeslot.completed',
                  link: { name: 'mounting-timeslot-registrations-completed' },
                },
                {
                  label: 'navigation.mountings.mounting.timeslot.approved',
                  link: { name: 'mounting-timeslot-registrations-approved' },
                },
              ],
              breadcrumbs: [
                {
                  label: 'navigation.mountings.DEFAULT',
                  link: '/mountings',
                },
              ],
            },
            children: [
              {
                path: '/:locale/mountings/:mountingId/timeslots/:mountingTimeslotId',
                name: 'mounting-timeslot-registrations-pending',
                component: PendingRegistrations,
                meta: {
                  roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
                  title: 'navigation.mountings.mounting.timeslot.DEFAULT',
                },
              },
              {
                path: '/:locale/mountings/:mountingId/timeslots/:mountingTimeslotId/completed',
                name: 'mounting-timeslot-registrations-completed',
                component: CompletedRegistrations,
                meta: {
                  roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_HELPER'],
                  title: 'navigation.mountings.mounting.timeslot.DEFAULT',
                },
              },
              {
                path: '/:locale/mountings/:mountingId/timeslots/:mountingTimeslotId/approved',
                name: 'mounting-timeslot-registrations-approved',
                component: ApprovedRegistrations,
                meta: {
                  roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
                  title: 'navigation.mountings.mounting.timeslot.DEFAULT',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/mountings-drivers',
    component: MountingLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      tabs: [
        {
          label: 'navigation.mountings.mounting.timeslot.pending',
          link: { name: 'mounting-drivers-pending' },
        },
        {
          label: 'navigation.mountings.mounting.timeslot.completed',
          link: { name: 'mounting-drivers-completed' },
        },
        {
          label: 'navigation.mountings.mounting.timeslot.approved',
          link: { name: 'mounting-drivers-approved' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.mountings.DEFAULT',
          link: '/mountings-drivers',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'mounting-drivers-pending',
        component: MountingDriversPendingRegistrations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          title: 'navigation.mountings.mounting.timeslot.pending',
        },
      },
      {
        path: 'completed',
        name: 'mounting-drivers-completed',
        component: MountingDriversCompletedRegistrations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          title: 'navigation.mountings.mounting.timeslot.completed',
        },
      },
      {
        path: 'approved',
        name: 'mounting-drivers-approved',
        component: MountingDriversApprovedRegistrations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          title: 'navigation.mountings.mounting.timeslot.approved',
        },
      },
    ],
  },
  {
    path: '/:locale/images',
    name: 'images',
    redirect: () => ({ name: 'new-photos' }),
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
    },
  },
  {
    path: '/:locale/images/photos',
    component: PhotosLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
      title: {
        text: 'navigation.images.photos.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.images.photos.new',
          link: { name: 'new-photos' },
        },
        {
          label: 'navigation.images.photos.history',
          link: { name: 'history-photos' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.images.photos.DEFAULT',
          link: '/images/photos',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'new-photos',
        component: NewPhotos,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
        },
      },
      {
        path: 'history',
        name: 'history-photos',
        component: HistoryPhotos,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
        },
      },
    ],
  },
  {
    path: '/:locale/images/verifications',
    component: VerificationsLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
      title: {
        text: 'navigation.images.verifications.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.images.verifications.new',
          link: { name: 'new-verifications' },
        },
        {
          label: 'navigation.images.verifications.history',
          link: { name: 'history-verifications' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.images.verifications.DEFAULT',
          link: '/images/verifications',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'new-verifications',
        component: NewVerifications,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
        },
      },
      {
        path: 'history',
        name: 'history-verifications',
        component: HistoryVerifications,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VERIFIER'],
        },
      },
    ],
  },
  {
    path: '/:locale/notifications',
    component: NotificationsLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.notifications.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.notifications.notifications',
          link: { name: 'notifications' },
        },
        {
          label: 'navigation.notifications.sentNotifications',
          link: { name: 'sent-notifications' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.notifications.DEFAULT',
          link: '/notifications',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'notifications',
        component: Notifications,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'sent-notifications',
        name: 'sent-notifications',
        component: NotificationSent,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/loyalty',
    name: 'loyalty',
    redirect: () => ({ name: 'interest-zones' }),
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
    },
  },
  {
    path: '/:locale/history',
    name: 'history',
    component: HistoryLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.history.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.history.general',
          link: { name: 'general' },
        },
        {
          label: 'navigation.history.driver',
          link: { name: 'driver' },
        },
        {
          label: 'navigation.history.usage',
          link: { name: 'usage' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.history.DEFAULT',
          link: '/history/general',
        },
      ],
    },
    children: [
      {
        path: 'general',
        name: 'general',
        component: HistoryGeneral,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'driver',
        name: 'driver',
        component: HistoryDriver,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'usage',
        name: 'usage',
        component: HistoryUsage,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/visibility',
    name: 'visibility',
    redirect: () => ({ name: 'plannings-draft' }),
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
    },
  },
  {
    path: '/:locale/visibility/plannings',
    // name: 'visibility',
    component: VisibilityPlanningsLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.visibility.plannings',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.visibility.planningsDraft',
          link: { name: 'plannings-draft' },
        },
        {
          label: 'navigation.visibility.planningsConfirmed',
          link: { name: 'plannings-confirmed' },
        },
        {
          label: 'navigation.visibility.planningsPassed',
          link: { name: 'plannings-passed' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.visibility.DEFAULT',
          link: '/visibility/plannings',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'plannings-draft',
        component: DraftVisibilityPlannings,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'confirmed',
        name: 'plannings-confirmed',
        component: ConfirmedVisibilityPlannings,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'passed',
        name: 'plannings-passed',
        component: PassedVisibilityPlannings,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/visibility/transfers',
    component: VisibilityTransfersLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
      title: {
        text: 'navigation.visibility.transfers',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.visibility.transfersOpen',
          link: { name: 'transfers' },
        },
        {
          label: 'navigation.visibility.transfersDone',
          link: { name: 'transfers-done' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.visibility.transfers',
          link: '/visibility/transfers',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'transfers',
        component: CurrentVisibilityTransfers,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
      {
        path: 'done',
        name: 'transfers-done',
        component: DoneVisibilityTransfers,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
    ],
  },
  {
    path: '/:locale/visibility/bicycles',
    component: VisibilityBicyclesLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
      title: {
        text: 'navigation.visibility.bicycles',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.visibility.bicyclesActive',
          link: { name: 'bicycles' },
        },
        {
          label: 'navigation.visibility.bicyclesArchived',
          link: { name: 'bicycles-archived' },
        },
        {
          label: 'navigation.visibility.bicyclesUsage',
          link: { name: 'bicycles-usage' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.visibility.DEFAULT',
          link: '/visibility/bicycles',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'bicycles',
        component: CurrentVisibilityBicycles,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
      {
        path: 'archived',
        name: 'bicycles-archived',
        component: ArchivedVisibilityBicycles,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
      {
        path: 'usage',
        name: 'bicycles-usage',
        component: UsageVisibilityBicycles,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
    ],
  },
  {
    path: '/:locale/visibility/locations',
    // name: 'visibility',
    component: VisibilityLocationsLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
      title: {
        text: 'navigation.visibility.locations',
        link: { name: 'locations' },
      },
      tabs: [
        {
          label: 'navigation.visibility.locations',
          link: { name: 'locations' },
        },
        {
          label: 'navigation.visibility.locationsInactive',
          link: { name: 'locations-inactive' },
        },
        {
          label: 'navigation.visibility.locationsArchived',
          link: { name: 'locations-archived' },
        },
        {
          label: 'navigation.visibility.locationsUsage',
          link: { name: 'locations-usage' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.visibility.DEFAULT',
          link: '/visibility/locations',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'locations',
        component: CurrentVisibilityLocations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
      {
        path: 'inactive',
        name: 'locations-inactive',
        component: InactiveVisibilityLocations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
      {
        path: 'archived',
        name: 'locations-archived',
        component: ArchivedVisibilityLocations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
      {
        path: 'usage',
        name: 'locations-usage',
        component: UsageVisibilityLocations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
    ],
  },
  {
    path: '/:locale/visibility/photos',
    // name: 'visibility',
    component: VisibilityPhotosLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
      title: {
        text: 'navigation.visibility.photos',
        link: { name: 'photos' },
      },
      tabs: [
        {
          label: 'navigation.visibility.photos',
          link: { name: 'photos' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.visibility.DEFAULT',
          link: '/visibility/photos',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'photos',
        component: VisibilityPhotos,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_VISIBILITY'],
        },
      },
    ],
  },
  {
    path: '/:locale/loyalty/interest-zones',
    component: LoyaltyLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.loyalty.interestZones',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.loyalty.interestZones',
          link: { name: 'interest-zones' },
        },
        {
          label: 'navigation.loyalty.rewards',
          link: { name: 'point-rewards' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.loyalty.DEFAULT',
          link: '/loyalty',
        },
        {
          label: 'navigation.loyalty.interestZones',
          link: '/loyalty/interest-zones',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'interest-zones',
        component: InterestZones,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: ':interestZoneId',
        name: 'interest-zone',
        component: InterestZone,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [],
          breadcrumbs: [
            {
              label: 'navigation.loyalty.DEFAULT',
              link: '/loyalty',
            },
            {
              label: 'navigation.loyalty.interestZones',
              link: '/loyalty/interest-zones',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'interest-zone-details',
            component: InterestZoneDetails,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.loyalty.interestZone',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/loyalty/point-rewards',
    component: LoyaltyLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.loyalty.rewards',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.loyalty.interestZones',
          link: { name: 'interest-zones' },
        },
        {
          label: 'navigation.loyalty.rewards',
          link: { name: 'point-rewards' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.loyalty.DEFAULT',
          link: '/loyalty',
        },
        {
          label: 'navigation.loyalty.rewards',
          link: '/loyalty/point-rewards',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'point-rewards',
        component: PointRewards,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: ':pointRewardId',
        component: PointReward,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [],
          breadcrumbs: [
            {
              label: 'navigation.loyalty.DEFAULT',
              link: '/loyalty',
            },
            {
              label: 'navigation.loyalty.rewards',
              link: '/loyalty/point-rewards',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'point-reward-details',
            component: PointRewardDetails,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.loyalty.pointRewardDetails',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/templates',
    component: TemplatesLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.templates.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.templates.focusPointTemplates',
          link: { name: 'focus-point-templates' },
        },
        {
          label: 'navigation.templates.statisticPointTemplates',
          link: { name: 'statistic-point-templates' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.templates.DEFAULT',
          link: '/templates',
        },
        {
          label: 'navigation.templates.DEFAULT',
          link: '/templates/statistic-point-templates',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'focus-point-templates',
        component: FocusPointTemplates,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'statistic-point-templates',
        name: 'statistic-point-templates',
        component: StatisticPointTemplates,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/content',
    name: 'content',
    redirect: { name: 'content.videos' },
  },
  {
    path: '/:locale/content/videos',
    name: 'content.videos',
    component: Videos,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      breadcrumbs: [
        {
          label: 'navigation.content.DEFAULT',
          link: '/content/videos',
        },
        {
          label: 'navigation.content.videos',
          link: '/content/videos',
        },
      ],
    },
  },
  {
    path: '/:locale/content/video-categories',
    name: 'content.video-categories',
    component: VideoCategories,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      breadcrumbs: [
        {
          label: 'navigation.content.DEFAULT',
          link: '/content/videos',
        },
        {
          label: 'navigation.content.video-categories',
          link: '/content/video-categories',
        },
      ],
    },
  },
  {
    path: '/:locale/content/faq',
    component: FaqLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.content.faq.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        { label: 'navigation.content.faq.faqQuestions', link: { name: 'faq-questions' } },
        { label: 'navigation.content.faq.faqSections', link: { name: 'faq-sections' } },
      ],
      breadcrumbs: [
        {
          label: 'navigation.content.faq.DEFAULT',
          link: '/content/faq',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'faq-questions',
        component: FaqQuestions,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'sections',
        name: 'faq-sections',
        component: FaqSections,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/advertisements',
    component: AdvertisementsLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'navigation.advertisements.DEFAULT',
        link: { name: 'advertisements' },
      },
      breadcrumbs: [
        {
          label: 'navigation.advertisements.DEFAULT',
          link: '/advertisements',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'advertisements',
        component: Advertisements,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
    ],
  },
  {
    path: '/:locale/settings',
    component: Settings,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'settings.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.settings.driverCommentTypes',
          link: { name: 'settings.comment-types' },
        },
        { label: 'navigation.settings.general', link: { name: 'settings.general' } },
        { label: 'navigation.settings.agb', link: { name: 'settings.agb' } },
        { label: 'navigation.settings.integrations', link: { name: 'settings.integrations' } },
      ],
      breadcrumbs: [
        {
          label: 'navigation.settings.DEFAULT',
          link: '/settings',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'settings.comment-types',
        component: DriverCommentTypes,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          title: 'navigation.settings.driverCommentTypes',
        },
      },
      {
        path: 'general',
        name: 'settings.general',
        component: General,
        meta: {
          roles: ['ROLE_SUPER_ADMIN'],
          title: 'navigation.settings.general',
        },
      },
      {
        path: 'agb',
        name: 'settings.agb',
        component: Agb,
        meta: {
          roles: ['ROLE_SUPER_ADMIN'],
          title: 'navigation.settings.agb',
        },
      },
      {
        path: 'integrations',
        name: 'settings.integrations',
        component: Integrations,
        meta: {
          roles: ['ROLE_SUPER_ADMIN'],
          title: 'navigation.settings.integrations',
        },
      },
    ],
  },
  {
    path: '/:locale/users',
    component: UsersLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
      title: {
        text: 'users',
        link: { name: 'dashboard' },
      },
      tabs: [
        { label: 'navigation.users.DEFAULT', link: { name: 'users' } },
        { label: 'navigation.users.logs', link: { name: 'logs' } },
      ],
      breadcrumbs: [
        {
          label: 'navigation.users.DEFAULT',
          link: '/users',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'users',
        component: Users,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: 'logs',
        name: 'logs',
        component: Logs,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        },
      },
      {
        path: '/:locale/users/:userId',
        component: User,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          tabs: [],
          breadcrumbs: [
            {
              label: 'navigation.users.DEFAULT',
              link: '/users',
            },
          ],
        },
        children: [
          {
            path: '',
            name: 'user-details',
            component: UserDetails,
            meta: {
              roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
              title: 'navigation.users.user.details',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/:locale/monitoring',
    component: MonitoringLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_MONITORING'],
      title: {
        text: 'navigation.monitoring.verification',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.monitoring.verificationsWithin48h',
          link: { name: 'monitoring-driver-verifications' },
        },
        {
          label: 'navigation.monitoring.campaignVerificationsWithin48h',
          link: { name: 'monitoring-campaign-verifications' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.monitoring.DEFAULT',
          link: '/monitoring',
        },
        {
          label: 'navigation.monitoring.verification',
          link: '/monitoring',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'monitoring-driver-verifications',
        component: MonitoringDriverVerifications,
        meta: {
          roles: ['ROLE_SUPER_ADMIN','ROLE_FINANCE_ADMIN', 'ROLE_MONITORING'],
          breadcrumbs: [
            {
              label: 'navigation.monitoring.DEFAULT',
              link: '/monitoring',
            },
            {
              label: 'navigation.monitoring.verification',
              link: '/monitoring',
            },
            {
              label: 'navigation.monitoring.drivers',
              link: '/monitoring',
            },
          ],
        },
      },
      {
        path: 'campaign-verifications',
        name: 'monitoring-campaign-verifications',
        component: MonitoringCampaignVerifications,
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_MONITORING'],
          breadcrumbs: [
            {
              label: 'navigation.monitoring.DEFAULT',
              link: '/monitoring',
            },
            {
              label: 'navigation.monitoring.verification',
              link: '/monitoring',
            },
            {
              label: 'navigation.monitoring.campaigns',
              link: '/monitoring/campaign-verifications',
            },
          ],
        },
      },
    ],
  },
  {
    path: '/:locale/invoices',
    component: InvoicesLayout,
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
      title: {
        text: 'navigation.invoicing.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'invoicing.statusValues.all',
          link: { name: 'invoices' },
        },
        {
          label: 'invoicing.statusValues.manual',
          link: { name: 'invoices-manual' },
        },
        {
          label: 'invoicing.statusValues.imported',
          link: { name: 'invoices-imported' },
        },
        {
          label: 'invoicing.statusValues.draft',
          link: { name: 'invoices-draft' },
        },
        {
          label: 'invoicing.statusValues.pending',
          link: { name: 'invoices-pending' },
        },
        {
          label: 'invoicing.statusValues.reminded',
          link: { name: 'invoices-reminded' },
        },
        {
          label: 'invoicing.statusValues.partially_paid',
          link: { name: 'invoices-partially-paid' },
        },
        {
          label: 'invoicing.statusValues.paid',
          link: { name: 'invoices-paid' },
        },
        {
          label: 'invoicing.statusValues.cancelled',
          link: { name: 'invoices-cancelled' },
        },
        {
          label: 'invoicing.statusValues.overdue',
          link: { name: 'invoices-overdue' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.invoicing.DEFAULT',
          link: '/invoices',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'invoices',
        component: Invoices,
        props: { variant: 'all' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'manual',
        name: 'invoices-manual',
        component: Invoices,
        props: { variant: 'manual' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'imported',
        name: 'invoices-imported',
        component: Invoices,
        props: { variant: 'imported' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'draft',
        name: 'invoices-draft',
        component: Invoices,
        props: { variant: 'draft' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'pending',
        name: 'invoices-pending',
        component: Invoices,
        props: { variant: 'pending' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'reminded',
        name: 'invoices-reminded',
        component: Invoices,
        props: { variant: 'reminded' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'partially-paid',
        name: 'invoices-partially-paid',
        component: Invoices,
        props: { variant: 'partially_paid' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'paid',
        name: 'invoices-paid',
        component: Invoices,
        props: { variant: 'paid' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'cancelled',
        name: 'invoices-cancelled',
        component: Invoices,
        props: { variant: 'cancelled' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
      {
        path: 'overdue',
        name: 'invoices-overdue',
        component: Invoices,
        props: { variant: 'overdue' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_CUSTOMER_INVOICING'],
        },
      },
    ],
  },
  {
    path: '/:locale/additional-payments',
    component: AdditionalPaymentsLayout,
    redirect: { name: 'additional-payments-open' },
    meta: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_DRIVER_INVOICING'],
      title: {
        text: 'navigation.additionalPayments.DEFAULT',
        link: { name: 'dashboard' },
      },
      tabs: [
        {
          label: 'navigation.additionalPayments.open',
          link: { name: 'additional-payments-open' },
        },
        {
          label: 'navigation.additionalPayments.paid',
          link: { name: 'additional-payments-paid' },
        },
      ],
      breadcrumbs: [
        {
          label: 'navigation.additionalPayments.DEFAULT',
          link: '/additional-payments',
        },
      ],
    },
    children: [
      {
        path: '',
        redirect: { name: 'additional-payments-open' },
      },
      {
        path: 'open',
        name: 'additional-payments-open',
        component: AdditionalPaymentsList,
        props: { variant: 'open' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_DRIVER_INVOICING'],
        },
      },
      {
        path: 'paid',
        name: 'additional-payments-paid',
        component: AdditionalPaymentsList,
        props: { variant: 'paid' },
        meta: {
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_FINANCE_ADMIN', 'ROLE_DRIVER_INVOICING'],
        },
      },
    ],
  },

  {
    path: '/:locale/profile',
    name: 'profile',
    component: Profile,
    meta: {
      title: 'pages.profile.title',
      breadcrumbs: [
        {
          label: 'navigation.profile',
          link: '/profile',
        },
      ],
    },
  },
  {
    path: '/:locale/404',
    name: '404',
    component: Page404,
  },
  {
    path: '/:locale?/:pathMatch(.*)+',
    redirect: { name: '404' },
  },
];

export default routes;
